(() => {
const page = document.getElementById('af-kids-preserve');
if (!page) return;

// Every color of the frame, from the Liquid island: id, color, price (cents), available,
// qty (on hand), image, hex. Black (the page's data-variant-id) is the default color.
let variants = [];
try { variants = JSON.parse((page.querySelector('[data-kids-variants]') || {}).textContent || '[]'); } catch (e) { variants = []; }
const byId = new Map(variants.map(v => [Number(v.id), v]));
const defaultId = Number(page.dataset.variantId);
const unit = Number(page.dataset.unitPrice);
if (!Number.isFinite(unit) || unit <= 0) return;
const defaultVariant = byId.get(defaultId) || { id: defaultId, color: 'Black', price: unit, available: true, qty: 9999, image: '', hex: '#111' };
if (!byId.has(defaultId)) { variants.unshift(defaultVariant); byId.set(defaultId, defaultVariant); }

// THREE different discounts decide the three prices here, and only the first is the bulk-ladder
// Function. Checkout applies whichever is worth most, so this has to do the same or the builder
// quotes a number the cart will not charge.
//   3 frames  the ladder, afl.bulk_offer "fixed:<unit cents>:<case cents>"  -> $1 off each
//   5 frames  DiscountAutomaticNode/1605049221190  Kids Artwork Gallery · 4+ frames save 10%
//   8 frames  DiscountAutomaticNode/1605049417798  Kids Artwork Gallery · 6+ frames save 15%
// The two Kids Artwork Gallery discounts are native automatic discounts scoped to this product
// alone; they are not readable from Liquid or JS, so their rates live here by hand. If either
// changes in Admin, change it here AND in templates/page.keep-their-art.liquid.
// They always beat the ladder from 4 units up — the cheapest colour is $16.99, so 10% is $1.69
// against the ladder's $1. Shopify floors the per-UNIT discount and multiplies, so floor here too.
// Verified against the live cart 2026-09-17: 3 -> $47.97, 5 -> $76.50, 8 -> $115.60.
const fixedOffer = (function () {
  const m = /^fixed:(\d+):(\d+)$/.exec((page.dataset.bulkOffer || '').trim());
  return m ? { three: parseInt(m[1], 10), full: parseInt(m[2], 10) } : null;
})();
function pctFor(q) { return q >= 8 ? 15 : q >= 4 ? 10 : 5; }
function discFor(price, q) {
  // Only the 3-frame set is the ladder's, and only it can carry a flat amount.
  if (q < 4 && fixedOffer) return fixedOffer.three;
  return Math.floor(price * pctFor(q) / 100);
}
function netUnit(price, q) { return price - discFor(price, q); }
function packFor(requested) { const n = Number(requested) || 3; return n <= 3 ? 3 : n <= 5 ? 5 : 8; }

// Color slots: one chosen variant id per frame on 3/5, a single case color on 8.
let slots = [defaultId, defaultId, defaultId];
let caseColor = defaultId;

function slotIds(q) { return q === 8 ? Array(8).fill(caseColor) : slots.slice(0, q); }
function calculateOffer(quantity) {
  const q = packFor(quantity);
  const pct = pctFor(q);
  const ids = slotIds(q);
  let subtotal = 0, total = 0;
  ids.forEach(id => { const p = (byId.get(id) || defaultVariant).price; subtotal += p; total += netUnit(p, q); });
  return { quantity: q, pct, ids, subtotal, total, savings: subtotal - total, freeShipping: q >= 5 };
}
function grouped(ids) {
  const m = new Map();
  ids.forEach(id => m.set(id, (m.get(id) || 0) + 1));
  return Array.from(m, ([id, count]) => ({ id, count, v: byId.get(id) || defaultVariant }));
}
// Colors the shopper picked more of than we have on hand — the add would fail at the cart.
function shortColors(ids) { return grouped(ids).filter(g => !g.v.available || (Number.isFinite(g.v.qty) && g.count > g.v.qty)); }

if (typeof document !== 'undefined') {
  const input = page.querySelector('[data-quantity]');
  const money = cents => new Intl.NumberFormat('en-US', { style: 'currency', currency: page.dataset.currency || 'USD' }).format(cents / 100);
  const offLabel = q => (q < 4 && fixedOffer) ? money(fixedOffer.three).replace(/\.00$/, '') + ' off each' : 'Save ' + pctFor(q) + '%';
  const slotsEl = page.querySelector('[data-color-slots]');
  const sameBtn = page.querySelector('[data-color-mix-same]');
  const mixTitle = page.querySelector('[data-color-mix-title]');
  const status = page.querySelector('[data-cart-status]');
  const addButton = page.querySelector('[data-add-kids-bundle]');
  let offer = calculateOffer(input ? input.value : 3);

  function optionLabel(v) {
    const price = money(v.price);
    if (!v.available) return v.color + ' — sold out';
    return v.color + ' — ' + price;
  }
  function renderSlots() {
    if (!slotsEl) return;
    const q = offer.quantity;
    const isCase = q === 8;
    if (mixTitle) mixTitle.textContent = isCase ? 'Case color' : 'Pick a color for each frame';
    if (sameBtn) sameBtn.hidden = isCase || new Set(slots.slice(0, q)).size < 2;
    const rows = isCase ? [{ label: 'All 8 frames', id: caseColor, i: -1 }] : slots.slice(0, q).map((id, i) => ({ label: 'Frame ' + (i + 1), id, i }));
    slotsEl.innerHTML = rows.map(r => {
      const v = byId.get(r.id) || defaultVariant;
      const opts = variants.map(o => '<option value="' + o.id + '"' + (Number(o.id) === Number(r.id) ? ' selected' : '') + (o.available ? '' : ' disabled') + '>' + optionLabel(o) + '</option>').join('');
      return '<label class="color-slot"><span>' + r.label + '</span><span class="dot" style="background:' + (v.hex || '#ccc') + '"></span><select data-slot="' + r.i + '" aria-label="' + r.label + ' color">' + opts + '</select></label>';
    }).join('');
  }
  // Color carousel on the builder image: every in-stock color, arrows + swatch dots. It is a
  // viewer — the selects decide what goes in the cart — and it jumps to the lead color
  // whenever the slots change, so the picture always matches the first frame chosen.
  const shown = variants.filter(v => v.available && v.image);
  let previewId = defaultId;
  const dotsEl = page.querySelector('[data-color-dots]');
  function showColor(id) {
    const v = byId.get(id); if (!v) return;
    previewId = id;
    const img = page.querySelector('[data-color-image]');
    if (img && v.image) { img.src = v.image; img.alt = v.color + ' My Mini Masterpiece front-loading frame with a white mat and children’s artwork'; }
    page.querySelectorAll('[data-color-caption]').forEach(el => el.textContent = v.color);
    const counter = page.querySelector('[data-color-counter]');
    if (counter) counter.textContent = (shown.findIndex(item => Number(item.id) === Number(id)) + 1) + ' / ' + shown.length + ' colors';
    if (dotsEl) dotsEl.querySelectorAll('[data-color-dot]').forEach(d => {
      const on = Number(d.dataset.colorDot) === Number(id);
      d.classList.toggle('active', on); d.setAttribute('aria-pressed', String(on));
    });
  }
  function stepColor(dir) {
    if (!shown.length) return;
    const i = shown.findIndex(v => Number(v.id) === Number(previewId));
    showColor(shown[(i + dir + shown.length) % shown.length].id);
  }
  if (dotsEl) {
    dotsEl.innerHTML = shown.map(v => '<button type="button" class="color-dot" data-color-dot="' + v.id + '" style="--swatch:' + (v.hex || '#ccc') + '" aria-label="' + v.color + ' — ' + money(v.price) + '" title="' + v.color + '" aria-pressed="false"></button>').join('');
    dotsEl.addEventListener('click', e => { const d = e.target.closest('[data-color-dot]'); if (d) showColor(Number(d.dataset.colorDot)); });
  }
  page.querySelectorAll('[data-carousel-prev]').forEach(b => b.addEventListener('click', () => stepColor(-1)));
  page.querySelectorAll('[data-carousel-next]').forEach(b => b.addEventListener('click', () => stepColor(1)));
  const colorStage = page.querySelector('[data-color-carousel]');
  if (colorStage) {
    colorStage.addEventListener('keydown', e => {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault(); stepColor(e.key === 'ArrowRight' ? 1 : -1);
    });
    let colorTouch = null;
    colorStage.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse' && !e.target.closest('button')) colorTouch = { x: e.clientX, y: e.clientY };
    });
    colorStage.addEventListener('pointerup', e => {
      if (!colorTouch) return;
      const dx = e.clientX - colorTouch.x, dy = e.clientY - colorTouch.y;
      colorTouch = null;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) stepColor(dx < 0 ? 1 : -1);
    });
    colorStage.addEventListener('pointercancel', () => { colorTouch = null; });
  }
  function syncVisual() {
    const lead = byId.get(offer.ids[0]) || defaultVariant;
    showColor(lead.id);
    const names = grouped(offer.ids);
    page.querySelectorAll('[data-color-tag]').forEach(el => el.textContent = 'My Mini Masterpiece · ' + (names.length > 1 ? 'Mixed colors' : lead.color));
    page.querySelectorAll('[data-color-summary]').forEach(el => el.textContent = names.map(g => g.count + '× ' + g.v.color).join(' · '));
  }
  function update(value) {
    const q = packFor(value);
    // Growing the set repeats the last chosen color; shrinking keeps the first frames.
    while (slots.length < q) slots.push(slots[slots.length - 1] || defaultId);
    offer = calculateOffer(q);
    if (input) input.value = offer.quantity;
    renderSlots();
    syncVisual();
    const short = shortColors(offer.ids);
    page.querySelectorAll('[data-count]').forEach(el => el.textContent = offer.quantity);
    page.querySelectorAll('[data-total]').forEach(el => el.textContent = money(offer.total));
    page.querySelectorAll('[data-select]').forEach(el => el.setAttribute('aria-pressed', String(Number(el.dataset.select) === offer.quantity)));
    page.querySelectorAll('[data-shipping]').forEach(el => el.textContent = offer.freeShipping ? 'Free standard U.S. shipping unlocked' : `Add ${5 - offer.quantity} more ${5 - offer.quantity === 1 ? 'frame' : 'frames'} for free shipping`);
    page.querySelectorAll('[data-progress]').forEach(el => el.style.width = `${Math.min(offer.quantity / 5, 1) * 100}%`);
    page.querySelectorAll('[data-saving]').forEach(el => el.textContent = `${offLabel(offer.quantity)} · ${money(offer.savings)} off · about ${money(Math.round(offer.total / offer.quantity))} per frame`);
    page.querySelectorAll('[data-was]').forEach(el => { el.textContent = money(offer.subtotal); el.hidden = !offer.savings; });
    page.querySelectorAll('[data-upgrade]').forEach(el => el.hidden = offer.quantity === 8);
    page.querySelectorAll('[data-upgrade-copy]').forEach(el => {
      // The case is one color: price the upgrade in the first chosen color.
      const lead = byId.get(offer.ids[0]) || defaultVariant;
      const caseTotal = 8 * netUnit(lead.price, 8);
      el.textContent = `Add ${8 - offer.quantity} ${8 - offer.quantity === 1 ? 'frame' : 'frames'} in ${lead.color} for ${money(Math.max(0, caseTotal - offer.total))} more and get ${offLabel(8).toLowerCase()} on the full case.`;
    });
    page.querySelectorAll('[data-minus]').forEach(el => el.disabled = offer.quantity === 3);
    page.querySelectorAll('[data-plus]').forEach(el => el.disabled = offer.quantity === 8);
    page.querySelectorAll('[data-discount-label]').forEach(el => el.textContent = fixedOffer ? 'Pack savings' : `Pack savings (${offer.pct}%)`);
    const totalLabel = page.querySelector('[data-total-label]');
    if (totalLabel) totalLabel.textContent = offer.quantity === 8 ? 'Full case total' : `${offer.quantity}-frame total`;
    if (addButton) addButton.disabled = short.length > 0;
    if (status) status.textContent = short.length
      ? short.map(g => g.v.available ? `Only ${g.v.qty} ${g.v.color} left — pick another color for the rest.` : `${g.v.color} is sold out.`).join(' ')
      : '';
  }
  if (input) {
    input.addEventListener('change', () => update(input.value));
    page.querySelectorAll('[data-select]').forEach(el => el.addEventListener('click', () => update(el.dataset.select)));
    page.querySelectorAll('[data-pick]').forEach(el => el.addEventListener('click', () => update(el.dataset.pick)));
    page.querySelectorAll('[data-minus]').forEach(el => el.addEventListener('click', () => update(offer.quantity === 8 ? 5 : 3)));
    page.querySelectorAll('[data-plus]').forEach(el => el.addEventListener('click', () => update(offer.quantity === 3 ? 5 : 8)));
    if (slotsEl) slotsEl.addEventListener('change', e => {
      const sel = e.target.closest('select[data-slot]');
      if (!sel) return;
      const id = Number(sel.value);
      const i = Number(sel.dataset.slot);
      if (i < 0) { caseColor = id; slots = slots.map(() => id); } // switching the case color is also the new default
      else slots[i] = id;
      update(offer.quantity);
    });
    if (sameBtn) sameBtn.addEventListener('click', () => { const id = slots[0]; slots = slots.map(() => id); caseColor = id; update(offer.quantity); });
    if (addButton) addButton.addEventListener('click', async () => {
      if (addButton.disabled) return;
      addButton.disabled = true;
      addButton.setAttribute('aria-busy', 'true');
      if (status) status.textContent = 'Adding your frames…';
      // One cart line per color; the Function sums them per product for the 5% tier.
      const items = grouped(offer.ids).map(g => ({ id: Number(g.id), quantity: g.count }));
      try {
        const response = await fetch(page.dataset.root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'We could not add your frames. Please try again.');
        window.location.assign(page.dataset.root + 'cart');
      } catch (error) {
        if (status) status.textContent = error.message || 'Please try again.';
        addButton.disabled = false;
        addButton.removeAttribute('aria-busy');
      }
    });
    update(input.value);
  }
}
// Manual carousel: preload before swapping, preserve the current photo on errors.
const gallery = page.querySelector('.mof-gallery');
if (gallery) {
  const photo = gallery.querySelector('[data-gallery-image]');
  const video = gallery.querySelector('[data-gallery-video]');
  const credit = gallery.querySelector('[data-gallery-credit]');
  const stage = gallery.querySelector('.mof-hero-image');
  const thumbs = [...gallery.querySelectorAll('[data-gallery-src]')];
  const previous = gallery.querySelector('[data-gallery-prev]');
  const next = gallery.querySelector('[data-gallery-next]');
  const counter = gallery.querySelector('[data-gallery-counter]');
  const error = gallery.querySelector('[data-gallery-error]');
  let current = 0, requested = 0, revision = 0, touchStart = null;
  async function show(index) {
    requested = (index + thumbs.length) % thumbs.length;
    const target = requested, request = ++revision, button = thumbs[target];
    stage.setAttribute('aria-busy','true');
    error.hidden = true;
    try {
      const isVideo = button.dataset.galleryType === 'video';
      if (video) video.pause();
      if (!isVideo) {
        const loaded = new Image();
        loaded.src = button.dataset.gallerySrc;
        await loaded.decode();
        if (request !== revision) return;
        photo.src = loaded.src;
        photo.alt = button.dataset.galleryAlt;
      }
      photo.hidden = isVideo;
      if (video) video.hidden = !isVideo;
      if (credit) credit.hidden = !isVideo;
      stage.classList.toggle('is-video', isVideo);
      gallery.querySelector('[data-gallery-caption]').textContent = button.dataset.galleryLabel;
      thumbs.forEach((item,i) => item.setAttribute('aria-pressed',String(i === target)));
      counter.textContent = `${String(target + 1).padStart(2,'0')} / ${String(thumbs.length).padStart(2,'0')}`;
      counter.setAttribute('aria-label',`Media ${target + 1} of ${thumbs.length}`);
      current = target;
      if (!isVideo && !window.matchMedia('(prefers-reduced-motion: reduce)').matches && photo.animate) {
        photo.getAnimations().forEach(animation => animation.cancel());
        photo.animate([{opacity:0.45},{opacity:1}],{duration:220,easing:'ease-out'});
      }
    } catch (_) {
      if (request !== revision) return;
      requested = current;
      error.textContent = 'This media could not load. Please try again.';
      error.hidden = false;
    } finally { if (request === revision) stage.removeAttribute('aria-busy'); }
  }
  thumbs.forEach((button,i) => button.addEventListener('click',() => show(i)));
  previous.hidden = next.hidden = thumbs.length < 2;
  previous.addEventListener('click',() => show(requested - 1));
  next.addEventListener('click',() => show(requested + 1));
  if (video) video.addEventListener('error', () => {
    if (video.hidden) return;
    error.textContent = 'The video could not load. Please try again or select a photo.';
    error.hidden = false;
  });
  gallery.addEventListener('keydown',event => {
    if (event.target.closest('video')) return;
    if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
      event.preventDefault();show(requested + (event.key === 'ArrowRight' ? 1 : -1));
    }
  });
  stage.addEventListener('pointerdown',event => {
    if (event.pointerType !== 'mouse' && !event.target.closest('button, video')) touchStart = {x:event.clientX,y:event.clientY};
  });
  stage.addEventListener('pointerup',event => {
    if (!touchStart) return;
    const dx = event.clientX - touchStart.x, dy = event.clientY - touchStart.y;
    touchStart = null;
    if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.5) show(requested + (dx < 0 ? 1 : -1));
  });
  stage.addEventListener('pointercancel',() => { touchStart = null; });
}
})();
